<img src="/assets/rendition.jpeg" [alt]="file.name" class="object-fill w-full thumbnail" appDefaultImg />
